import { render, staticRenderFns } from "./matching.vue?vue&type=template&id=2333bf40&scoped=true"
import script from "./matching.vue?vue&type=script&lang=js"
export * from "./matching.vue?vue&type=script&lang=js"
import style0 from "./matching.vue?vue&type=style&index=0&id=2333bf40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2333bf40",
  null
  
)

export default component.exports